/**
 * BS CUSTOM: Quantity Input Override
 *
 * Überschreibt die QuantityInput Klasse aus global.js
 * um Metafeld-basierte Mengensteuerung zu unterstützen.
 *
 * Änderungen zum Original:
 * - Verwendet min-Attribut statt hardcoded "1"
 * - Minus-Button wird bei tatsächlichem Minimum disabled
 * - Fallback-Werte respektieren das min-Attribut
 */
/**
 * BS CUSTOM: Quantity Input Override
 * Klasse umbenannt in BSQuantityInput, um Konflikte mit global.js zu vermeiden.
 */
class BSQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    // Buttons finden und Listener binden
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.setMinimumDisable();

    // Validierung bei manueller Tastatureingabe (beim Verlassen des Feldes)
    this.input.addEventListener("change", () => this.validateInput());
    
    // Visuelles Update der Buttons während des Tippens
    this.input.addEventListener("input", () => this.setMinimumDisable());
  }

  validateInput() {
    const minValue = parseInt(this.input.getAttribute('min')) || 1;
    const stepValue = parseInt(this.input.getAttribute('step')) || 1;
    let currentValue = parseInt(this.input.value);

    // 1. Fall: Keine Zahl oder kleiner als Minimum
    if (isNaN(currentValue) || currentValue < minValue) {
      currentValue = minValue;
    }

    // 2. Fall: Intervall-Validierung (Rundung auf nächstes Vielfaches)
    // Wir berechnen die Schritte ausgehend vom Minimum
    const stepsFromMin = Math.floor((currentValue - minValue) / stepValue);
    currentValue = minValue + (stepsFromMin * stepValue);

    // Wert nur aktualisieren, wenn er sich geändert hat
    if (this.input.value != currentValue) {
      this.input.value = currentValue;
      // Wichtig für Themes, die den Warenkorb per AJAX aktualisieren
      this.input.dispatchEvent(this.changeEvent);
    }
    
    this.setMinimumDisable();
  }

  setMinimumDisable() {
    const minValue = parseInt(this.input.getAttribute('min')) || 1;
    const currentValue = parseInt(this.input.value);
    const minusButton = this.querySelector('button[name="minus"]');
    
    if (minusButton) {
      const isAtMin = currentValue <= minValue;
      minusButton.classList.toggle("disabled", isAtMin);
      // Optional: Cursor-Feedback
      minusButton.style.pointerEvents = isAtMin ? "none" : "auto";
      minusButton.style.opacity = isAtMin ? "0.5" : "1";
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    // Nutze currentTarget, um sicher den Button zu erwischen (auch wenn man das Icon darin anklickt)
    const button = event.currentTarget;
    
    // Die nativen Methoden stepUp/Down berücksichtigen automatisch das step-Attribut
    button.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    this.input.dispatchEvent(this.changeEvent);
    this.setMinimumDisable();
  }
}

// Registrierung unter dem Namen, den du auch im Liquid verwendest
customElements.define("bs-quantity-input", BSQuantityInput);
/**
 * BS CUSTOM: Form-Submit Validierung
 * Validiert und korrigiert Mengen beim Submit
 */
document.addEventListener('DOMContentLoaded', function() {
  // BS CUSTOM: Form-Submit Validierung - Menge auf gültiges Vielfaches begrenzen
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', function() {
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
      const maxValue = parseInt(quantityInput.getAttribute('max'));
      const stepValue = parseInt(quantityInput.getAttribute('step')) || 1;
      let currentValue = parseInt(quantityInput.value);

      // Validierung und Korrektur
      if (isNaN(currentValue) || currentValue < minValue) {
        currentValue = minValue;
      }

      // BS CUSTOM: Auf gültiges Vielfaches runden
      if (stepValue > 1) {
        const stepsFromMin = Math.round((currentValue - minValue) / stepValue);
        currentValue = minValue + (stepsFromMin * stepValue);
      }

      // BS CUSTOM: Maximum-Prüfung
      if (maxValue && currentValue > maxValue) {
        // Runde auf gültiges Vielfaches ab
        if (stepValue > 1) {
          const stepsFromMin = Math.floor((maxValue - minValue) / stepValue);
          currentValue = minValue + (stepsFromMin * stepValue);
        } else {
          currentValue = maxValue;
        }
      }

      // Wert im Input aktualisieren
      quantityInput.value = currentValue;
    });
  });
});
